var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOtherGoal(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 160 140",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: 80.1,
    y1: 45.27,
    x2: 35.22,
    y2: 45.27,
    fill: "none",
    stroke: "#0af",
    strokeMiterlimit: 10,
    strokeDasharray: "4 1 2 1"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 42.43,
    y1: 42.27,
    x2: 69.91,
    y2: 42.27,
    fill: "none",
    stroke: "#0af",
    strokeMiterlimit: 10,
    strokeDasharray: "4 1 2 1"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 65.04,
    y1: 39.27,
    x2: 52.23,
    y2: 39.27,
    fill: "none",
    stroke: "#0af",
    strokeMiterlimit: 10,
    strokeDasharray: "4 1 2 1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.93,48.27H35.22m40.89,0h-18m12.23,3.44H58.15m15.67,3.44H63.88",
    fill: "none",
    stroke: "#0af",
    strokeMiterlimit: 10,
    strokeDasharray: "4 1 2 1"
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "84.37 115.82 19.42 116.52 51.35 65.27 84.37 115.82",
    fill: "#999",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 87.53,
    y1: 48.73,
    x2: 87.15,
    y2: 13.68,
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "111.35 29.17 95.19 29.34 87.32 29.43 87.23 21.55 87.15 13.68 95.02 13.6 111.18 13.42 103.39 21.38 111.35 29.17",
    fill: "#ffea80",
    stroke: "#ffd500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "135.38 121.98 41.26 123 87.53 48.73 135.38 121.98",
    fill: "#999",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "81.08 80.52 85.73 72.93 103.34 72.93 87.53 48.73 67.72 80.52 81.08 80.52",
    fill: "#fff",
    stroke: "#fff",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "103.34 72.93 87.53 48.73 67.72 80.52",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "67.72 80.71 81.08 80.71 85.73 73.12 103.34 73.12",
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeDasharray: "4 1 2 1"
  })), /*#__PURE__*/React.createElement("line", {
    x1: 98.37,
    y1: 41.29,
    x2: 137.73,
    y2: 101.79,
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeWidth: 3,
    strokeDasharray: "12 3"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "96.7 48.99 98.37 41.29 106.07 42.96",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOtherGoal);
export default __webpack_public_path__ + "static/media/other-goal.c351f693.svg";
export { ForwardRef as ReactComponent };